import { IBasicData } from "../../interfaces/Igeneral.interface";

export class BOOdontologyPatientBackground {
  id:number;
  tempId?:string;
  personId:number;
  itemType:string;
  itemName:string;
  details?:string;
  }

